<div class="marquee-container" *ngIf="show" [style.--duration]="duration">
    <div class="marquee-content">
        <ng-content></ng-content>
    </div>
</div>
